export const CommonReducer = function () {};

const nostoLocalSessionId =
  typeof localStorage !== 'undefined'
    ? localStorage.getItem('nostoSessionId')
    : '';

const commonInitialState = {
  omneo: {
    apiToken: null,
    client: {},
  },
  triggerRoute: false,
  nostoSessionID: nostoLocalSessionId,
  globalPromoTiles: null,
};

CommonReducer.handleAction = (globalState = commonInitialState, action) => {
  switch (action.type) {
    case 'common.omneo.access':
      return {
        ...globalState,
        omneo: {
          apiToken: action.data.apiToken || globalState.omneo.apiToken,
          client: action.data.client || globalState.omneo.apiToken,
        },
      };
    case 'FRONTASTIC_ROUTE':
      return {
        ...globalState,
        triggerRoute: true,
      };
    case 'Frontend.Tracking.PageView':
      return {
        ...globalState,
        triggerRoute: false,
      };
    case 'setNostoSessionId':
      return {
        ...globalState,
        nostoSessionID:
          action.data.nostoSessionID || globalState.nostoSessionID,
      };
    case 'globalPromoTiles':
      return {
        ...globalState,
        globalPromoTiles: action.data,
      };
    default:
  }

  return globalState;
};
